const SAMPLES = 30;
const intervals: number[] = [];
let lastTs: number | null = null;
let collecting = true;

if (typeof window !== 'undefined') {
  const onFrame = (ts: number) => {
    if (!collecting) return;
    if (lastTs !== null) {
      intervals.push(ts - lastTs);
      if (intervals.length > SAMPLES) intervals.shift();
    }
    lastTs = ts;
    if (intervals.length < SAMPLES) {
      requestAnimationFrame(onFrame);
    }
  };
  requestAnimationFrame(onFrame);
}

function stddev(arr: number[]): number {
  const n = arr.length;
  if (n < 2) return 0;
  const mean = arr.reduce((a, b) => a + b, 0) / n;
  const v = arr.reduce((a, b) => a + (b - mean) ** 2, 0) / n;
  return Math.sqrt(v);
}

export function getRafJitter(): number | undefined {
  collecting = false;
  if (intervals.length < 10) return undefined;
  return Number(stddev(intervals).toFixed(4));
}
